import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { actions, selectors } from '@lbmx/app-state';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  takeUntil,
  tap,
} from 'rxjs/operators';
import { ConfigProvider } from 'src/app/provider/config-provider';

export const SESSION_SETUP_ROUTE = 'session-setup';

@Injectable({
  providedIn: 'root',
})
export class SessionService implements OnDestroy {
  public switchAccount$ = new BehaviorSubject<boolean>(false);

  private shouldDestroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private store: Store,
    private configPrv: ConfigProvider,
  ) {
    this.store
      .pipe(
        select(selectors.marketplaces),
        filter(
          ({ marketplaces }) =>
            marketplaces?.length && marketplaces instanceof Array,
        ),
        map(({ marketplace }) => marketplace),
        distinctUntilChanged(),
        filter((marketplace) => !marketplace),
        tap(() => this._navigate()),
        takeUntil(this.shouldDestroy$),
      )
      .subscribe();
  }

  public switchMarketplace() {
    this.store.dispatch(
      actions.updateUserProfileMarketplace({
        marketplace: '',
        endPoints: this.configPrv.AppSetting,
      }),
    );
  }

  public switchAccount() {
    this.switchAccount$.next(true);
    this._navigate();
  }

  private _navigate() {
    return this.router.navigate([SESSION_SETUP_ROUTE], {
      skipLocationChange: true,
      queryParams: {
        nextUrl: this.router.routerState.snapshot.url,
      },
    });
  }

  public ngOnDestroy() {
    this.shouldDestroy$.next();
  }
}
